import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconPortfolio = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M4.422 23l8.311-13.17a1.232 1.232 0 01.978-.481M4.422 23H23L14.689 9.83a1.232 1.232 0 00-.978-.481M4.422 23H1l3.667-6.585 2.126 2.828m6.918-9.894V1l6.789.049a.505.505 0 01.456.292.515.515 0 01-.062.542L19.782 3.29a.518.518 0 000 .64l1.116 1.408a.518.518 0 01-.123.756.505.505 0 01-.271.08H13.71m-4.938 9.931l2.296 1.925a.979.979 0 001.323-.055l.628-.627a.979.979 0 011.382 0l.628.627a.979.979 0 001.323.055l2.296-1.925",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconPortfolio.displayName = "IconPortfolio";

export { IconPortfolio };
